export default __webpack_public_path__ + "static/media/tri-bottom.90b5cc1a.svg";